"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatDate(date) {
    function pad(m) {
        return ('0' + m).slice(-2);
    }
    // YYYY-MM-DD HH:mm:ss GMT+XX00
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${date.toTimeString().split(" (")[0]}`;
}
exports.default = formatDate;
